import { useFetchUpcomingScheduledEvent } from '@/api/hooks/useFetchUpcomingScheduledEvent'
import { SchedulingActions } from '@/components/HomePage/ScheduleActions'
import { UpcomingAppointment } from '@/components/HomePage/UpcomingAppointment'

import { Skeleton } from '@/ui/core/skeleton'
import { VStack } from '@/ui/core/stack'

const PatientActionsCta = () => {
	const { scheduledEvent, isLoading, hasScheduledAppointment, hasNoScheduledEvents } =
		useFetchUpcomingScheduledEvent()

	return (
		<VStack gap={32} className="flex-1 justify-center items-center bg-white">
			<Skeleton isLoading={isLoading} className={'h-12 w-3/5 max-w-60'}>
				{hasScheduledAppointment && (
					<UpcomingAppointment appointment={scheduledEvent.appointment!} />
				)}
				{hasNoScheduledEvents && <SchedulingActions />}
			</Skeleton>
		</VStack>
	)
}

export { PatientActionsCta }
